// DeliveryOptionsInfo.js
import React from 'react';
import * as S from "./styles"; // Import your styles
import { auth, firestore } from "../../firebaseConfig";
import { collection, doc, getDoc } from "firebase/firestore"; // Import Firestore functions

interface DeliveryOptionsInfoProps {
  selectedOption: string;
  setSelectedOption: (value: string) => void;
  pricing: { [key: string]: string };
  setAddress: (value: string) => void; // Add this line
}

const DeliveryOptionsInfo: React.FC<DeliveryOptionsInfoProps> = ({ selectedOption, setSelectedOption, pricing, setAddress }) => { // Add setAddress here
  const handleHomeDeliveryChange = async () => {
    setSelectedOption("homeDelivery");

    if (auth.currentUser) {
      const userDoc = doc(collection(firestore, "users"), auth.currentUser.uid);
      const docSnap = await getDoc(userDoc);

      if (docSnap.exists() && docSnap.data().address) {
        setAddress(docSnap.data().address);
      }
    }
  };
  return (
    <S.RadioTable>
      <tr>
        <td>
          <input
            type="radio"
            value="storeCollect"
            checked={selectedOption === "storeCollect"}
            onChange={() => setSelectedOption("storeCollect")}
          />
          <span>Store Collect</span>
        </td>
        
        <td>
          <span className="pricing">{pricing.storeCollect}</span>
        </td>
      </tr>
      <tr>
        <td>
          <input
            type="radio"
            value="cargoDropOff"
            checked={selectedOption === "cargoDropOff"}
            onChange={() => setSelectedOption("cargoDropOff")}
          />
          <span>Cargo Drop-off</span>
        </td>
        
        <td>
          <span className="pricing">{pricing.cargoDropOff}</span>
        </td>
      </tr>
      <tr>
        <td>
          <input
            type="radio"
            value="homeDelivery"
            checked={selectedOption === "homeDelivery"}
            onChange={() => setSelectedOption("homeDelivery")}
          />
          <span>Home Delivery</span>
        </td>
        
        
        <td>
          <span className="pricing">{pricing.homeDelivery}</span>
        </td>
      </tr>
    </S.RadioTable>
  );
};

export default DeliveryOptionsInfo;
